import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,Grid2, Typography } from "@mui/material";
import { useLanguage } from "../../../../Context/LangContext";
// const headers = ["Details", "Contact person", "Contact no", "Address", "Email"];
// const data = [
//   { details: "Chief Executive officer", person: "Jitesh Shetty", contact: "7400362816",  address: "A-2, Bandra Liberty, 98-B, Hill Road, Bandra West. Mumbai 400050", email: "ceo@tradeboss.co" },
//   { details: "Complaince Officer", person: "D N Dubey", contact: "9833452816",  address: "A-2, Bandra Liberty, 98-B, Hill Road, Bandra West. Mumbai 400050",email: "compliance@tradeboss.co"  },
//   { details: "Head of customer care", person: "Sunil Shetty", contact: "9820783641", address: "A-2, Bandra Liberty, 98-B, Hill Road, Bandra West. Mumbai 400050" , email: "support@tradeboss.co" },
//   { details: "Customer Care", person: "Laxmi Salian", contact: "9421628197",  address: "A-2, Bandra Liberty, 98-B, Hill Road, Bandra West. Mumbai 400050" , email: "support@tradeboss.co" },
// ];

const translations = {
  en: {
    heading: "Escalation Matrix",
    headers: ["Details", "Contact person", "Contact no", "Address", "Email"],
    data: [
      {
        details: "Chief Executive Officer",
        person: "Jitesh Shetty",
        contact: "7400362816",
        address: "A-2, Bandra Liberty, 98-B, Hill Road, Bandra West, Mumbai 400050",
        email: "ceo@tradeboss.co",
      },
      {
        details: "Compliance Officer",
        person: "D N Dubey",
        contact: "9833452816",
        address: "A-2, Bandra Liberty, 98-B, Hill Road, Bandra West, Mumbai 400050",
        email: "compliance@tradeboss.co",
      },
      {
        details: "Head of Customer Care",
        person: "Sunil Shetty",
        contact: "9820783641",
        address: "A-2, Bandra Liberty, 98-B, Hill Road, Bandra West, Mumbai 400050",
        email: "support@tradeboss.co",
      },
      {
        details: "Customer Care",
        person: "Laxmi Salian",
        contact: "9421628197",
        address: "A-2, Bandra Liberty, 98-B, Hill Road, Bandra West, Mumbai 400050",
        email: "support@tradeboss.co",
      },
    ],
  },

  hi: {
    heading: "एस्केलेशन मैट्रिक्स",
    headers: ["विवरण", "संपर्क व्यक्ति", "संपर्क नंबर", "पता", "ईमेल"],
    data: [
      {
        details: "मुख्य कार्यकारी अधिकारी",
        person: "जीतेश शेट्टी",
        contact: "7400362816",
        address: "A-2, बांद्रा लिबर्टी, 98-B, हिल रोड, बांद्रा वेस्ट, मुंबई 400050",
        email: "ceo@tradeboss.co",
      },
      {
        details: "अनुपालन अधिकारी",
        person: "डी. एन. दुबे",
        contact: "9833452816",
        address: "A-2, बांद्रा लिबर्टी, 98-B, हिल रोड, बांद्रा वेस्ट, मुंबई 400050",
        email: "compliance@tradeboss.co",
      },
      {
        details: "ग्राहक सेवा प्रमुख",
        person: "सुनील शेट्टी",
        contact: "9820783641",
        address: "A-2, बांद्रा लिबर्टी, 98-B, हिल रोड, बांद्रा वेस्ट, मुंबई 400050",
        email: "support@tradeboss.co",
      },
      {
        details: "ग्राहक सेवा",
        person: "लक्ष्मी सालियन",
        contact: "9421628197",
        address: "A-2, बांद्रा लिबर्टी, 98-B, हिल रोड, बांद्रा वेस्ट, मुंबई 400050",
        email: "support@tradeboss.co",
      },
    ],
  },

  ma: {
    heading: "एस्कलेशन मॅट्रिक्स",
    headers: ["तपशील", "संपर्क व्यक्ती", "संपर्क क्रमांक", "पत्ता", "ईमेल"],
    data: [
      {
        details: "मुख्य कार्यकारी अधिकारी",
        person: "जितेश शेट्टी",
        contact: "7400362816",
        address: "A-2, बांद्रा लिबर्टी, 98-B, हिल रोड, बांद्रा वेस्ट, मुंबई 400050",
        email: "ceo@tradeboss.co",
      },
      {
        details: "अनुपालन अधिकारी",
        person: "डी. एन. दुबे",
        contact: "9833452816",
        address: "A-2, बांद्रा लिबर्टी, 98-B, हिल रोड, बांद्रा वेस्ट, मुंबई 400050",
        email: "compliance@tradeboss.co",
      },
      {
        details: "ग्राहक सेवा प्रमुख",
        person: "सुनील शेट्टी",
        contact: "9820783641",
        address: "A-2, बांद्रा लिबर्टी, 98-B, हिल रोड, बांद्रा वेस्ट, मुंबई 400050",
        email: "support@tradeboss.co",
      },
      {
        details: "ग्राहक सेवा",
        person: "लक्ष्मी सालियन",
        contact: "9421628197",
        address: "A-2, बांद्रा लिबर्टी, 98-B, हिल रोड, बांद्रा वेस्ट, मुंबई 400050",
        email: "support@tradeboss.co",
      },
    ],
  },
  gu: {
    heading: "એસ્કલેશન મેટ્રિક્સ",
    headers: ["વિગતો", "સંપર્ક વ્યક્તિ", "સંપર્ક નંબર", "સરનામું", "ઈમેલ"],
    data: [
      {
        details: "ચીફ એક્ઝિક્યુટિવ ઓફિસર",
        person: "જિતેશ શેટ્ટી",
        contact: "7400362816",
        address: "A-2, બાન્દ્રા લિબર્ટી, 98-B, હિલ રોડ, બાન્દ્રા વેસ્ટ, મુંબઈ 400050",
        email: "ceo@tradeboss.co",
      },
      {
        details: "કમ્પ્લાયન્સ ઓફિસર",
        person: "ડી. એન. દુબે",
        contact: "9833452816",
        address: "A-2, બાન્દ્રા લિબર્ટી, 98-B, હિલ રોડ, બાન્દ્રા વેસ્ટ, મુંબઈ 400050",
        email: "compliance@tradeboss.co",
      },
      {
        details: "ગ્રાહક સેવા વડા",
        person: "સુનીલ શેટ્ટી",
        contact: "9820783641",
        address: "A-2, બાન્દ્રા લિબર્ટી, 98-B, હિલ રોડ, બાન્દ્રા વેસ્ટ, મુંબઈ 400050",
        email: "support@tradeboss.co",
      },
      {
        details: "ગ્રાહક સેવા",
        person: "લક્ષ્મી સાલિયન",
        contact: "9421628197",
        address: "A-2, બાન્દ્રા લિબર્ટી, 98-B, હિલ રોડ, બાન્દ્રા વેસ્ટ, મુંબઈ 400050",
        email: "support@tradeboss.co",
      },
    ],
  },

  kn: {
    heading: "ಎಸ್ಕಲೇಷನ್ ಮ್ಯಾಟ್ರಿಕ್ಸ್",
    headers: ["ವಿವರಗಳು", "ಸಂಪರ್ಕ ವ್ಯಕ್ತಿ", "ಸಂಪರ್ಕ ಸಂಖ್ಯೆ", "ವಿಳಾಸ", "ಇಮೇಲ್"],
    data: [
      {
        details: "ಮುಖ್ಯ ಕಾರ್ಯನಿರ್ವಾಹಕ ಅಧಿಕಾರಿ",
        person: "ಜಿತೇಶ್ ಶೆಟ್ಟಿ",
        contact: "7400362816",
        address: "A-2, ಬ್ಯಾಂಡ್ರಾ ಲಿಬರ್ಟಿ, 98-B, ಹಿಲ್ ರಸ್ತೆ, ಬ್ಯಾಂಡ್ರಾ ವೆಸ್ಟ್, ಮುಂಬೈ 400050",
        email: "ceo@tradeboss.co",
      },
      {
        details: "ಅನುಸರಣಾಧಿಕಾರಿ",
        person: "ಡಿ. ಎನ್. ದುಬೆ",
        contact: "9833452816",
        address: "A-2, ಬ್ಯಾಂಡ್ರಾ ಲಿಬರ್ಟಿ, 98-B, ಹಿಲ್ ರಸ್ತೆ, ಬ್ಯಾಂಡ್ರಾ ವೆಸ್ಟ್, ಮುಂಬೈ 400050",
        email: "compliance@tradeboss.co",
      },
      {
        details: "ಗ್ರಾಹಕ ಆರೈಕೆ ಮುಖ್ಯಸ್ಥ",
        person: "ಸುನಿಲ್ ಶೆಟ್ಟಿ",
        contact: "9820783641",
        address: "A-2, ಬ್ಯಾಂಡ್ರಾ ಲಿಬರ್ಟಿ, 98-B, ಹಿಲ್ ರಸ್ತೆ, ಬ್ಯಾಂಡ್ರಾ ವೆಸ್ಟ್, ಮುಂಬೈ 400050",
        email: "support@tradeboss.co",
      },
      {
        details: "ಗ್ರಾಹಕ ಆರೈಕೆ",
        person: "ಲಕ್ಷ್ಮಿ ಸಾಲಿಯನ್",
        contact: "9421628197",
        address: "A-2, ಬ್ಯಾಂಡ್ರಾ ಲಿಬರ್ಟಿ, 98-B, ಹಿಲ್ ರಸ್ತೆ, ಬ್ಯಾಂಡ್ರಾ ವೆಸ್ಟ್, ಮುಂಬೈ 400050",
        email: "support@tradeboss.co",
      },
    ],
  },
};


const EscalationMatrixTable = () =>{
  const { language } = useLanguage();
  const { heading,headers, data } = translations[language] || translations.en;
    return(


  <Grid2 sx={{padding: "0px 84px 50px 89px" }}>

    <Typography sx={{ fontFamily: "Inter500",fontWeight:"500", fontSize: "calc(24px + var(--font-delta))",lineHeight:"100%", textAlign: "left", padding: "109px 0px 21px 0px",color:"#ffffff"}}>
          {heading}
    </Typography>
  <TableContainer component={Paper} elevation={0} sx={{ backgroundColor: "transparent", borderRadius: "24px" }}>
      <Table>
      <TableHead>
              <TableRow sx={{ backgroundColor: "#F2F2F2", }}>
          {headers.map((header, i) => (
            <TableCell
              key={i}
              sx={{
                border: "none",
                padding: { xs: "8px ", sm: "10px ", md: "12px" },
                textAlign: "center",
                fontSize: { xs: "calc(10px + var(--font-delta))", sm: "calc(12px + var(--font-delta))", md: "14pxcalc(14px + var(--font-delta))" },
                fontWeight: "700 !important",
                fontFamily: "Inter700",
                color:"#000000",

              }}
            >
              {header}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((row, rowIndex) => (
          <TableRow
            key={rowIndex}
            sx={{

              "&:not(:last-child) td": {
                borderBottom: "2px solid #DFE0EB", // ✅ here
              },
            }}
          >
            {Object.values(row).map((cell, i) => (
              <TableCell
                key={i}
                sx={{
                  border: "none",
                  padding: { xs: "8px ", sm: "10px  ", md: "12px" },
                  fontSize: { xs: "calc(10px + var(--font-delta))", sm: "calc(12px + var(--font-delta))", md: "14pxcalc(14px + var(--font-delta))" },
                  textAlign:"center",
                  fontWeight: 400,
                  fontFamily: "Inter400",
                  color: "#333333",
                  backgroundColor: "#ffffff",
                }}
              >
                {cell}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
  </Grid2>
);
  }

export default EscalationMatrixTable;
